import * as React from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { queryClient } from '@src/services/common';
import * as queries from '@src/services/queries';
import CriticalEventForm from '@src/features/CriticalEventFormContainer';
import SettingsContainer from '@shared/components/SettingsContainer';
import { useEditingContext } from './context';

const Events = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { search } = useLocation();
  const { onDispose, onUpdate, cachedValues } = useEditingContext();

  const handleDispose = React.useCallback(() => {
    onDispose?.();
    void navigate(
      {
        pathname: '..',
        search,
      },
      { replace: true },
    );
  }, [onDispose, navigate, search]);

  const handleSave = React.useCallback<GetProp<typeof CriticalEventForm, 'onSave'>>(() => {
    void queryClient.invalidateQueries({
      queryKey: [queries.QUERY_KEY_CRITICAL_EVENTS],
    });
    handleDispose();
  }, [handleDispose]);

  return (
    <SettingsContainer header="Edit Critical Event">
      <CriticalEventForm
        id={id}
        initialValue={cachedValues}
        onChange={onUpdate}
        onCancel={handleDispose}
        onSave={handleSave}
      />
    </SettingsContainer>
  );
};

export const EventsEditing = React.memo(Events);
